export default {
    introduction: [
        {
            "text": "厦门广场位于思明区鹭江道2号。项目总"
        },
        {
            "text": "建筑面积约5.3万，总高度137米。地下3"
        },
        {
            "text": "层停车场，共201个停车位。地上共37层，"
        },
        {
            "text": "1层为挑高12米豪华大堂，其中包括咖啡"
        },
        {
            "text": "厅，2层为大厦专属食堂，11层为空中花"
        },
        {
            "text": "园、行政酒廊，12-15层为多功能会议，"
        },
        {
            "text": "31-37层为集团自用及合作企业，其余楼"
        },
        {
            "text": "层为写字楼对外租赁部分，项目已投入使"
        },
        {
            "text": "用。"
        },
        {
            "text": ""
        }
    ],

    buildingIndex: {
        airQuality: '良好',
        peopleOutIn: '234/34',
        ele: '3232',
        water: '343'
    },
    peopleOutIn: {
        time: ['08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10'],
        name: ['进', '出'],
        out: [21, 32, 54, 23, 43, 43, 32, 50],
        in: [4, 13, 14, 15, 18, 13, 8, 3]
    },
    energy: {
        energyRatio: 89,
        totalEnergy: 54329,
        totalLoad: 4356.4
    },
    people: {
        staff: 1664,
        security: 670,
        visitor: 854,
    },
    flowAnalysis: {
        staff: 1200,
        flow: 1543
    },
    flowYearAnalysis: {
        time: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        '2020': [123, 234, 843, 754, 534, 435, 676, 893, 923, 605, 504, 343],
        '2021': [167, 314, 883, 794, 624, 555, 716, 953, 1093, 735, 634, 413],
    },
    regionLease: {
        'A区': {
            useArea: 1534,
            rentArea: 2478,
            rentedArea: 1244,
            notRentedArea: 1234
        },
        'B区': {
            useArea: 1234,
            rentArea: 1244,
            rentedArea: 1244,
            notRentedArea: 1234
        },
        'C区': {
            useArea: 1234,
            rentArea: 1244,
            rentedArea: 1244,
            notRentedArea: 1234
        }
    },
    enterprise: [
        {
            "name": "Hightopo",
            "bgVisible": true,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "厦门图扑软件",
            "bgVisible": false,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "上海图扑软件",
            "bgVisible": true,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "天津图扑软件",
            "bgVisible": false,
            "legalPerson": "李*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "青岛图扑软件",
            "bgVisible": true,
            "legalPerson": "于*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "大连图扑软件",
            "bgVisible": false,
            "legalPerson": "薄*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "成都图扑软件",
            "bgVisible": true,
            "legalPerson": "郑*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        },
        {
            "name": "北京图扑软件",
            "bgVisible": false,
            "legalPerson": "林*",
            "peopleNumber": "150 人",
            "area": "2500 m³"
        }
    ],
    leaseArea: {
        area: [3234, 2355, 1233],
        time: ['一月', '二月', '三月', '四月', '五月', '六月'],
        useArea: [50, 60, 60, 71, 65, 58],
        rentedArea: [120, 134, 156, 161, 144, 134],
        notRentedArea: [263, 254, 216, 181, 174, 154],
    },
    prices: {
        region: [1900, 1500, 1200],
        A: {
            'A01': 2100,
            'A02': 2050,
            'A03': 1910,
            'A04': 1800,
            'A05': 1850,
            'A06': 1920
        },
        B: {
            'B01': 2100,
            'B02': 2050,
            'B03': 1910,
            'B04': 1800,
            'B05': 1850,
            'B06': 1920,
            'B07': 1800,
            'B08': 1850,
            'B09': 1920,
            'B10': 1850,
            'B11': 1920
        },
        C: {
            'C01': 2100,
            'C02': 2050,
            'C03': 1910,
            'C04': 1800,
            'C05': 1850,
            'C06': 1920,
            'C07': 1910,
            'C08': 1800,
        }
    },

    pageLight: {
        environment: [
            {
                "region": "首层1A-1B候车分区11",
                "sensor": "1-1",
                "value": 280
            },
            {
                "region": "首层1A-2B候车分区",
                "sensor": "1-2",
                "value": 430
            },
            {
                "region": "首层2A-1B候车分区",
                "sensor": "2-1",
                "value": 334
            },
            {
                "region": "首层1A-10B候车分区",
                "sensor": "1-10",
                "value": 210
            },
            {
                "region": "首层4A-1B候车分区",
                "sensor": "4-1",
                "value": 452
            },
            {
                "region": "首层4A-2B候车分区",
                "sensor": "4-2",
                "value": 533
            },
            {
                "region": "首层4A-3B候车分区",
                "sensor": "4-3",
                "value": 283
            },
            {
                "region": "首层1A-5B候车分区",
                "sensor": "1-5",
                "value": 432
            }
        ],
        lighting: [
            "周一",
            "周二",
            "周三",
            "周四",
            "周五",
            "周六",
            "周日"
        ],
        alarm: [
            {
                "level": "一级",
                "levelText": "一级",
                "time": "2021-04-29 12:25",
                "content": "传感器-syl发生报警，请注意需",
                "content2": "停运维修。"
            },
            {
                "level": "二级",
                "levelText": "二级",
                "time": "2021-04-29 12:25",
                "content": "传感器-syl发生报警，请注意需",
                "content2": "停运维修。"
            },
            {
                "level": "二级",
                "levelText": "二级",
                "time": "2021-04-29 12:25",
                "content": "传感器-syl发生报警，请注意需",
                "content2": "停运维修。"
            },
            {
                "level": "一级",
                "levelText": "一级",
                "time": "2021-04-29 12:25",
                "content": "传感器-syl发生报警，请注意需",
                "content2": "停运维修。"
            },
            {
                "level": "二级",
                "levelText": "二级",
                "time": "2021-04-29 12:25",
                "content": "传感器-syl发生报警，请注意需",
                "content2": "停运维修。"
            }
        ]
    },

    pageFire: {
        highRiskFire: [
            {
                "level": "火警",
                "time": "2021-04-29 12:25",
                "content": "东电梯南/设备火警：010070点型感烟/0333"
            },
            {
                "level": "火警",
                "time": "2021-04-29 12:25",
                "content": "东电梯南/设备火警：010070点型感烟/0333"
            },
            {
                "level": "火灾",
                "time": "2021-04-29 12:25",
                "content": "东电梯南/设备火警：010070点型感烟/0333"
            },
            {
                "level": "火警",
                "time": "2021-04-29 12:25",
                "content": "东电梯南/设备火警：010070点型感烟/0333"
            },
            {
                "level": "火灾",
                "time": "2021-04-29 12:25",
                "content": "东电梯南/设备火警：010070点型感烟/0333"
            },
            {
                "level": "火警",
                "time": "2021-04-29 12:25",
                "content": "东电梯南/设备火警：010070点型感烟/0333"
            },
            {
                "level": "火灾",
                "time": "2021-04-29 12:25",
                "content": "东电梯南/设备火警：010070点型感烟/0333"
            }
        ]
    }
};

